import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_membership_points_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  card_no: fromDatatype.VarcharDatatypeInterface;
  doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_line_guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  points_type: fromDatatype.VarcharDatatypeInterface;
  points_value: fromDatatype.NumericDatatypeInterface;
  points_balance: fromDatatype.NumericDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_crm_membership_points_RowClass
  implements bl_crm_membership_points_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  card_no: fromDatatype.VarcharDatatypeInterface;
  doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_line_guid: fromDatatype.GuidDataFieldInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  points_type: fromDatatype.VarcharDatatypeInterface;
  points_value: fromDatatype.NumericDatatypeInterface;
  points_balance: fromDatatype.NumericDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
